// Static fallback data for categories & services.
// Also served from backend /api/categories and /api/services.

export const CATEGORIES = [
    {
        slug: "pharmaceuticals",
        name: "Pharmaceutical Formulations",
        tagline: "WHO-GMP & EU-GMP grade finished dosages",
        span: "md:col-span-7",
        tone: "dark",
        image: "https://images.unsplash.com/photo-1587854692152-cbe660dbde88?auto=format&fit=crop&w=1400&q=80",
        items: [
            "Antibacterials — Levofloxacin, Roxithromycin, Azithromycin",
            "Antifungals — Fluconazole, Itraconazole",
            "Antiallergics — Levocetirizine, Montelukast",
            "Antidiabetics — Metformin, Acarbose, Glimepiride",
            "Antihypertensives — Telmisartan, Amlodipine, Losartan",
            "GI / PPI — Pantoprazole, Rabeprazole, Omeprazole",
            "Analgesics — Diclofenac, Paracetamol, Mefenamic Acid, Serratiopeptidase",
            "Neuro / CNS — Carbamazepine, Pregabalin, Gabapentin",
            "Vitamins, Minerals & Multivitamin ranges",
        ],
    },
    {
        slug: "ayush",
        name: "Ayurveda, Siddha & Unani",
        tagline: "AYUSH-licensed classical & proprietary medicines",
        span: "md:col-span-5",
        tone: "earth",
        image: "https://images.pexels.com/photos/20689437/pexels-photo-20689437.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        items: [
            "Classical Ayurvedic churnas, kashayas & asavas",
            "Siddha healing formulations",
            "Unani tonics, majoons & syrups",
            "Yoga & meditation resources for wellness centres",
            "Panchakarma supplies & therapeutic oils",
        ],
    },
    {
        slug: "nutraceuticals",
        name: "Nutraceuticals & Supplements",
        tagline: "Protein, probiotics, herbal extracts",
        span: "md:col-span-4",
        tone: "light",
        image: "https://images.pexels.com/photos/3683098/pexels-photo-3683098.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        items: [
            "Protein powders & amino acid blends",
            "Probiotic sachets & capsules",
            "Herbal & botanical extracts",
            "Immunity boosters & antioxidants",
            "Weight management & metabolic health",
        ],
    },
    {
        slug: "juices-herbs",
        name: "Juices & Herbal Extracts",
        tagline: "Aloe vera, amla, wheatgrass & fruit blends",
        span: "md:col-span-4",
        tone: "light",
        image: "https://images.pexels.com/photos/616833/pexels-photo-616833.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        items: [
            "Aloe vera, wheatgrass, amla, noni juices",
            "Fruit & vegetable blends",
            "Herbal concentrates & tinctures",
        ],
    },
    {
        slug: "personal-care",
        name: "Personal & Skin Care",
        tagline: "Private-label cosmetics & herbal topicals",
        span: "md:col-span-4",
        tone: "light",
        image: "https://images.pexels.com/photos/4041392/pexels-photo-4041392.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        items: [
            "Herbal skin gels, lotions & creams",
            "Face wash, scrubs, gels & toners",
            "Shower gels, soaps & body washes",
            "Massage oils & dental massage pastes",
            "Powders & syrups for personal care",
        ],
    },
    {
        slug: "hair-care",
        name: "Hair Care Range",
        tagline: "Shampoo, conditioners, gels, serums",
        span: "md:col-span-3",
        tone: "light",
        image: "https://images.pexels.com/photos/3993449/pexels-photo-3993449.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        items: [
            "Hair cleansing shampoos",
            "Conditioners & hair masks",
            "Hair gels, serums & oils",
        ],
    },
    {
        slug: "pain-relief",
        name: "Pain Relief Range",
        tagline: "Oils, balms, drops, gels & sprays",
        span: "md:col-span-4",
        tone: "light",
        image: "https://images.pexels.com/photos/4046316/pexels-photo-4046316.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        items: [
            "Pain relief oils & balms",
            "Topical gels & sprays",
            "Roll-on & drop formats",
        ],
    },
    {
        slug: "hospital-equipment",
        name: "Hospital Devices, Equipment & Furniture",
        tagline: "Turnkey supply for hospitals & clinics",
        span: "md:col-span-5",
        tone: "dark",
        image: "https://images.pexels.com/photos/7108115/pexels-photo-7108115.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        items: [
            "Diagnostic & surgical instruments",
            "ICU, OT & ward equipment",
            "Hospital beds, stretchers & trolleys",
            "Furniture, bedding, bandages, gowns & linen",
        ],
    },
    {
        slug: "hospital-consumables",
        name: "Sanitation, Waste Management & CSSD",
        tagline: "Chemicals, disinfectants & hospital hygiene",
        span: "md:col-span-4",
        tone: "light",
        image: "https://images.pexels.com/photos/4099355/pexels-photo-4099355.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        items: [
            "Sanitation chemicals & disinfectants",
            "Medical waste management consumables",
            "Housekeeping & laundry chemicals",
            "CSSD & catering unit supplies",
        ],
    },
    {
        slug: "vaccines-family-planning",
        name: "Vaccines & Family Planning",
        tagline: "Immunisation, IUDs & disease prevention",
        span: "md:col-span-3",
        tone: "earth",
        image: "https://images.pexels.com/photos/3952241/pexels-photo-3952241.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        items: [
            "Vaccines for immunisation programmes",
            "Intrauterine devices (IUDs)",
            "Family planning products",
            "Health promotion & disease prevention kits",
        ],
    },
];

export const SERVICES = [
    {
        slug: "planning-architecture",
        name: "Hospital Planning & Medical Architecture",
        description:
            "End-to-end planning of OPD, indoor wards, ICU, labour rooms and operation theatres.",
    },
    {
        slug: "medical-lab",
        name: "Medical Lab Planning",
        description:
            "Microbiology, Pathology & Biochemistry lab design, reagents and machines.",
    },
    {
        slug: "medical-imaging",
        name: "Medical Imaging Planning",
        description:
            "Radiology suite planning, installation and equipment supply.",
    },
    {
        slug: "medical-gas",
        name: "Medical Gas Plants",
        description:
            "Design, installation and commissioning of oxygen, vacuum & medical gas pipelines.",
    },
    {
        slug: "blood-bank",
        name: "Blood Transfusion Units",
        description:
            "Licensing, planning and operations of blood banks & transfusion services.",
    },
    {
        slug: "mortuary",
        name: "Mortuary Services",
        description:
            "Mortuary planning, designing and equipping with cold storage.",
    },
    {
        slug: "cssd-laundry-catering",
        name: "CSSD, Laundry & Catering",
        description:
            "Centralised sterile services, hospital laundry and catering unit setup.",
    },
    {
        slug: "his",
        name: "Hospital Information System",
        description:
            "HIS deployment, EMR and operations digital transformation.",
    },
];

export const MARQUEE_ITEMS = [
    "Levofloxacin",
    "Pantoprazole",
    "Metformin",
    "Telmisartan",
    "Carbamazepine",
    "Fluconazole",
    "Diclofenac",
    "Paracetamol",
    "Ayurvedic Churnas",
    "Siddha Tonics",
    "Unani Majoons",
    "Aloe Vera Juice",
    "Amla Juice",
    "Herbal Skincare",
    "Hair Serums",
    "Pain Relief Balm",
    "Hospital Beds",
    "ICU Equipment",
    "OT Planning",
    "Medical Gas Plants",
    "CSSD Supplies",
    "Vaccines",
    "IUDs",
    "Surgical Instruments",
];
